module.exports = __webpack_public_path__ + "static/media/uni-campus-1.960ce79d.jpg";